import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const StrollerIllustration = ({ width = 40, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <path fill="#FFBF00" d="M0 11.616L0 13.151 3.836 13.151 3.836 18.082 5.37 18.082 5.37 11.616z" />
        <path
          fill="#ED585D"
          d="M3.836 18.082c0 9.986 8.096 18.082 18.082 18.082S40 28.068 40 18.082 31.904 0 21.918 0v18.082H3.836z"
        />
        <path fill="#AD0016" d="M40 18.082C40 8.096 31.904 0 21.918 0v18.082H40z" />
        <path fill="#000" d="M21.918 36.164C31.904 36.164 40 28.068 40 18.082S31.904 0 21.918 0v36.164z" opacity=".1" />
        <path
          fill="#FFBF00"
          d="M12 25.534c3.994 0 7.232 3.238 7.232 7.233C19.232 36.762 15.994 40 12 40s-7.232-3.238-7.232-7.233c0-3.995 3.238-7.233 7.232-7.233"
        />
        <path
          fill="#FFE6AB"
          d="M12 27.616c2.845 0 5.15 2.306 5.15 5.15 0 2.846-2.305 5.15-5.15 5.15s-5.15-2.304-5.15-5.15c0-2.844 2.305-5.15 5.15-5.15"
        />
        <path
          fill="#FFE6AB"
          d="M12 27.616c-.037 0-.073.002-.109.003v10.296l.109.002c2.845 0 5.15-2.305 5.15-5.15s-2.305-5.151-5.15-5.151"
        />
        <path
          fill="#FFBF00"
          d="M30.191 25.534c3.995 0 7.233 3.238 7.233 7.233 0 3.995-3.238 7.233-7.233 7.233-3.994 0-7.232-3.238-7.232-7.233 0-3.995 3.238-7.233 7.232-7.233"
        />
        <path
          fill="#FFE6AB"
          d="M30.191 27.616c2.845 0 5.151 2.306 5.151 5.15 0 2.846-2.306 5.15-5.15 5.15-2.846 0-5.15-2.304-5.15-5.15 0-2.844 2.304-5.15 5.15-5.15"
        />
        <path
          fill="#FFE6AB"
          d="M30.191 27.616h-.036v10.3h.036c2.845 0 5.151-2.304 5.151-5.15 0-2.844-2.306-5.15-5.15-5.15"
        />
        <path
          fill="#000"
          d="M12 25.534l-.109.002v14.46c.036 0 .072.004.109.004 3.994 0 7.232-3.238 7.232-7.233 0-3.995-3.238-7.233-7.232-7.233M30.191 25.534h-.036V40h.036c3.995 0 7.233-3.238 7.233-7.232 0-3.995-3.238-7.233-7.233-7.233"
          opacity=".1"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
